// hooks/usePropertyForm.js
import { useState } from 'react';

const initialFormData = {
    customerId: null,
    title: '',
    description: '',
    propertyTypeId: null,
    listingTypeId: null,
    furnishingStatusId: null,
    ownershipTypeId: null,
    availabilityStatusId: null,
    propertyAge: '',
    price: '',
    isNegotiable: false,
    loanEligible: false,
    bachelorsAllowed: false,
    reraApproved: false,
    reraId: '',
    address: '',
    city: '',
    state: '',
    pincode: '',
    landmark: '',
    latitude: '',
    longitude: '',
    carParking: '',
    numberOfBedrooms: '',
    numberOfBathrooms: '',
    numberOfBalconies: '',
    numberOfKitchens: '',
    locationMapUrl: '',
    videoUrl: '',
    facingDirectionId: null,
    imageUrls: [],
    floorPlanUrl: [],
    amenityIds: [],
    featureIds: [],
    email: '',
    whatsappNumber: '',
    brokerageApplicable: false,
    brokerageAmount: '',
    chatEnabled: true,
    isVerifiedContact: true,
    viewsCount: 0,
    likesCount: 0
};

export const usePropertyForm = () => {
    const [formData, setFormData] = useState(initialFormData);
    const [errors, setErrors] = useState({});

    const handleInputChange = (field, value) => {
        setFormData((prev) => ({ ...prev, [field]: value }));
        setErrors((prevErrors) => ({
            ...prevErrors,
            [field]: '',
        }));
    };

    const updateContactDetails = (id) => {
        
    };

    const toggleItem = (field, id) => {
        setFormData((prev) => {
            const current = prev[field] || [];
            const updated = current.includes(id)
                ? current.filter((item) => item !== id)
                : [...current, id];
            return { ...prev, [field]: updated };
        });
    };

    const handleAmenityToggle = (id) => toggleItem('amenityIds', id);
    const handleFeatureToggle = (id) => toggleItem('featureIds', id);

    const validateForm = (media = [], areaDetails = [], propertyTypeSelectedFields = []) => {
        const newErrors = {};
        if (!formData.customerId) newErrors.customerId = 'Customer is required';
        if (!formData.title.trim()) newErrors.title = 'Property title is required';
        if (!formData.description.trim()) newErrors.description = 'Description is required';
        if (!formData.propertyTypeId) newErrors.propertyTypeId = 'Property type is required';
        if (!formData.listingTypeId) newErrors.listingTypeId = 'Listing type is required';
        if (!formData.price || isNaN(formData.price)) newErrors.price = 'Valid price is required';
        if (!media || media.length === 0) newErrors.media = 'At least one property image is required';
        
        // Validate Area Size only if it's visible/required for this property type
        if (propertyTypeSelectedFields.includes('area')) {
            const areaSize = areaDetails.find(detail => detail.label === 'area');
            if (!areaSize?.value || areaSize.value.trim() === '' || isNaN(areaSize.value) || parseFloat(areaSize.value) <= 0) {
                newErrors.areaSize = 'Area Size is required and must be a valid positive number';
            }
        }
        
        // Validate location selection through Autocomplete
        if (!formData.latitude || !formData.longitude || formData.latitude === '' || formData.longitude === '') {
            newErrors.location = 'Please select a location using the search field above';
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const resetForm = () => {
        setFormData(initialFormData);
        setErrors({});
    };

    const clearError = (field) => {
        setErrors((prevErrors) => {
            const newErrors = { ...prevErrors };
            delete newErrors[field];
            return newErrors;
        });
    };

    return {
        formData,
        setFormData,
        errors,
        setErrors,
        handleInputChange,
        updateContactDetails,
        handleAmenityToggle,
        handleFeatureToggle,
        validateForm,
        clearError,
        resetForm
    };
};
